<template>
    <div>
        <b-table
            show-empty
            empty-text="ไม่มีรายละเอียดข้อมูลส่วนตัว"
            :items="personal"
            :fields="fieldsPersonal"
            responsive
            :busy="busy"
            class="scroll-bar-pop"
        >
            <div slot="table-busy" class="text-center">
                <BlockUI >
                    <div class="loader"></div>
                </BlockUI>
            </div>
            <template slot="shop_code" slot-scope="row">
                <span>{{row.item.shop_code}}</span><br>
                <span>{{($THEME.packagePrefix) ? $THEME.packagePrefix[row.item.package] : row.item.package}}</span>
            </template>
            <template slot="owner_name" slot-scope="row">
                <span>{{row.item.owner_name}}</span><br>
                <span>{{row.item.owner_name_eng}}</span>
            </template>
            <template slot="owner_tel" slot-scope="row">
                <span>{{row.item.owner_tel}}</span><br>
                <span>{{row.item.email}}</span><br>
                <span>{{row.item.id_line}}</span>
            </template>
            <template slot="payment_type" slot-scope="row">
                <span>{{ statusPayment(row.item.payment_type).title }}</span>
            </template>
            <template slot="actions" slot-scope="row">
                <button
                    class="btn btn-sm btn-info px-3"
                    @click="$router.push({name:'branceedit',params:{Id:row.item.id}})"
                >แก้ไข</button>
                <button
                    class="btn btn-sm btn-danger px-3"
                    @click="($emit('showComfirmModal',row.item.id))"
                    v-if="auth0RoleUsage('brancemanagedelete')"
                >ลบ</button>
            </template>
        </b-table>
    </div>
</template>
<script>
import { statusPayment } from "@/plugins/statusPayment.js"
import { auth0RoleUsage } from "@/helpers/auth0"

export default {
    name:"TableBrancePersonal",
    props: {
        busy: Boolean,
        personal: Array,
    },
    data: () => ({
        statusPayment: statusPayment,
        auth0RoleUsage: auth0RoleUsage
    }),
    computed:{
        fieldsPersonal(){
            let fields = [
                { key: "last_updated", label: "วันที่อัพเดตข้อมูลล่าสุด", sortable: true },
                { key: "shop_code", label: "ร้าน", sortable: true ,class: 'text-center'},
                { key: "name", label: "ชื่อร้าน/ชื่อสาขา", sortable: true },
                { key: "owner_name", label: "ชื่อเจ้าของร้าน", sortable: true },
                { key: "owner_tel", label: "ติดต่อ", sortable: true },
                { key: "payment_type", label: "ประเภทการชำระเงิน", sortable: true },
                { key: "actions", label: "การจัดการ", sortable: true }
            ]
            return fields
        },
    }
   
}
</script>